/* eslint-disable */
YP.OrgaManager = () => {
    return {
        init() {
            if($('.js-pre-refund').length > 0) {
                YP.ModalManager().setPreCallSuccess(this.initPreRefundForm);
            }
            
            $('.btn-widget-agenda').live('click', function() {
                $('.widget_preview_agenda').toggle();
            });

            $('.switch-feature').live('click', this.displayFeatureBills);
            $('.switch-ticketing').live('click', this.displayTicketingBills);

            YP.OrgaManager().initWidgetStyleForm();
        },
        displayFeatureBills() {
            $('.ticketing-bills').hide();
            $('.feature-bills').show();
            $('.switch-feature').addClass('active');
            $('.switch-ticketing').removeClass('active');
        },
        displayTicketingBills() {
            $('.feature-bills').hide();
            $('.ticketing-bills').show();
            $('.switch-ticketing').addClass('active');
            $('.switch-feature').removeClass('active');
        },
        initPreRefundForm() {
            $('#ticketing_pre_refund_select').die().live('change', function() {
                ticketingId = this.value;
                $('.waiting').show();
                $.ajax({
                    type : 'get',
                    url : $('#ticketing_pre_refund_select').data('url'),
                    data: {
                        ticketingId : ticketingId
                    },
                    success : function(data) {
                        YP.ModalManager().displayModal(data);
                        $('#ticketing_pre_refund_select').val(ticketingId);
                    }
                });
            });
        },
        initWidgetStyleForm(e) {
            const spectrumConfiguration = {
                preferredFormat: "hex",
                clickoutFiresChange: true,
                showInitial: true,
                showInput: true,
                chooseText: "Choisir",
                cancelText: "Annuler",
                showPalette: true,
                showSelectionPalette: true,
                palette: [],
                localStorageKey: "yurplan.spectrum"
            };
            $('#assoWidgetStyleForm_height_auto').on("change", function(e){
                if($(this).is(":checked")){
                    $('#orga_widget_custom_height').hide()
                }
                else{
                    $('#orga_widget_custom_height').show()
                }
            });
            $('#assoWidgetStyleForm_width_auto').on("change", function(e){
                if($(this).is(":checked")){
                    $('#orga_widget_custom_width').hide()
                }
                else{
                    $('#orga_widget_custom_width').show()
                }
            });
            $("#assoWidgetStyleForm_primary_color").spectrum(spectrumConfiguration);
            $("#assoWidgetStyleForm_background_color").spectrum(spectrumConfiguration);
            $('#widgetOrgaStyleForm').submit(function widgetOrgaStyleFormSubmit(e){
                e.preventDefault();
                var form = $(this);
                $.post(
                    form.attr('action'),
                    form.serialize(),
                    function widgetOrgaStyleFormSubmitSuccess(data) {
                        $('.widget-code-preview').html(data);
                        YP.WidgetPro().init();
                    }
                );
                return false;
            });
        }
    }
};


window.addEventListener("load", function() {
    YP.OrgaManager().init();
});
